import {
    STUDENT_GET_PROFILE_REQUEST,
    STUDENT_GET_PROFILE_SUCCESS,
    STUDENT_GET_PROFILE_FAILURE,
    STUDENT_UPDATE_PROFILE_REQUEST,
    STUDENT_UPDATE_PROFILE_SUCCESS,
    STUDENT_UPDATE_PROFILE_FAILURE,
    STUDENT_GET_BOOKINGS_REQUEST,
    STUDENT_GET_BOOKINGS_SUCCESS,
    STUDENT_GET_BOOKINGS_FAILURE,
    STUDENT_GET_ORDERS_REQUEST,
    STUDENT_GET_ORDERS_SUCCESS,
    STUDENT_GET_ORDERS_FAILURE,
    STUDENT_GET_SUBSCRIPTIONS_REQUEST,
    STUDENT_GET_SUBSCRIPTIONS_SUCCESS,
    STUDENT_GET_SUBSCRIPTIONS_FAILURE,
    SET_UTMS,
} from '../actions/types';

const initialState = {
    loadingProfile: true,
    loadingBookings: true,
    loadingOrders: true,
    subscriptionsLoading: true,
    updatingProfile: false,
    profile: null,
    bookings: [],
    orders: [],
    subscriptions: [],
    error: null,
    utm_details: {},
};

export default function profile(state = initialState, action) {
    switch (action.type) {
        case STUDENT_GET_PROFILE_REQUEST:
            return {
                ...state,
                loadingProfile: true,
            };
        case STUDENT_GET_PROFILE_SUCCESS:
        case STUDENT_UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                profile: action.payload,
                loadingProfile: false,
                updatingProfile: false,
                error: null,
            };
        case STUDENT_GET_PROFILE_FAILURE:
        case STUDENT_UPDATE_PROFILE_FAILURE:
        case STUDENT_GET_BOOKINGS_FAILURE:
        case STUDENT_GET_ORDERS_FAILURE:
            return {
                ...state,
                loadingProfile: false,
                loadingBookings: false,
                loadingOrders: false,
                updatingProfile: false,
                error: action.payload,
            };
        case STUDENT_GET_BOOKINGS_REQUEST:
            return {
                ...state,
                loadingBookings: true,
            };
        case STUDENT_GET_ORDERS_REQUEST:
            return {
                ...state,
                loadingOrders: true,
            };

        case STUDENT_GET_BOOKINGS_SUCCESS:
            return {
                ...state,
                bookings: action.payload,
                loadingBookings: false,
            };
        case STUDENT_GET_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                loadingOrders: false,
            };
        case STUDENT_UPDATE_PROFILE_REQUEST:
            return {
                ...state,
                error: null,
                updatingProfile: true,
            };

        case STUDENT_GET_SUBSCRIPTIONS_REQUEST:
            return {
                ...state,
                subscriptionsLoading: true,
            };

        case STUDENT_GET_SUBSCRIPTIONS_SUCCESS:
            return {
                ...state,
                subscriptionsLoading: false,
                subscriptions: action.payload,
            };

        case STUDENT_GET_SUBSCRIPTIONS_FAILURE:
            return {
                ...state,
                subscriptionsLoading: false,
            };
        case SET_UTMS:
            return {
                ...state,
                utm_details: {
                    ...state.utm_details,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
}
